import React from "react";

const CampaignVendor = props => {
	const {items, value, onChange, disabled} = props;

	return (
		<select disabled={disabled} className="edit-field-styles select-primary" onChange={(e) => onChange(e.target.selectedOptions[0].value)} value={value || ''}>
			<option key="-1" value="-1">Select Vendor</option>
			{ items.map((t, i) => (<option value={t.value} key={i}>{t.label}</option>)) }
		</select>
	)
};

export default CampaignVendor;
